/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { recaptchaBadgeSelector } from '../configs';

const waitForElement = (selector: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      // Check if the element is already in the DOM
      if (document.querySelector(selector)) {
        resolve();
        return;
      }

      // Create an observer to watch for changes
      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve();
          observer.disconnect();
        }
      });

      // Start observing the body for child changes only
      observer.observe(document.body, {
        childList: true,
        subtree: false,
      });
    } catch (error) {
      reject(error);
    }
  });
};

export const checkRecaptchaBadge = async (): Promise<boolean> => {
  try {
    await waitForElement(recaptchaBadgeSelector);
    return true;
  } catch (error) {
    return false;
  }
};
